import type { FC } from "react";

interface NoSearchMatchEmptyStateProps {
  noun: "chain" | "asset";
}

export const NoSearchMatchEmptyState: FC<NoSearchMatchEmptyStateProps> = ({
  noun,
}) => (
  <div className="flex flex-col items-center justify-center gap-3 px-6 py-4 text-center">
    <p className="m-0 font-semibold text-gray-700 text-lg leading-[26px]">
      Try another search
    </p>
    <p className="m-0 max-w-[288px] font-medium text-gray-600 text-sm leading-5">
      {`No ${noun}s matched your entry. Check for typos or try a different entry.`}
    </p>
  </div>
);
